import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setModelType } from 'src/slices/chat';
import { RootState, useDispatch } from 'src/store';
import { RESPONSE_MODEL_TYPES } from 'src/constants';

export const ModelTypeSelect = () => {
  const dispatch = useDispatch();
  const { selectedModelType } = useSelector((state: RootState) => state.chat);

  useEffect(() => {
    if (!selectedModelType) {
      dispatch(setModelType(RESPONSE_MODEL_TYPES[0].value));
    }
  }, []);

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, width: '300px' }}>
      <FormControl sx={{ width: '99%' }}>
        <InputLabel id="model-type-label">Select Model *</InputLabel>
        <Select
          size="small"
          sx={{
            fontSize: '0.875rem',
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          }}
          value={selectedModelType}
          labelId="model-type-label"
          id="model-type-label-select"
          label="Select Model"
          onChange={(e: any) => {
            dispatch(setModelType(e.target.value));
          }}
        >
          {RESPONSE_MODEL_TYPES.map((res) => (
            <MenuItem
              sx={{ '&:hover': { backgroundColor: '#DCEEFF' }, color: '#10385D' }}
              value={res.value}
              key={res.value}
            >
              {res.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
